import PropTypes from "prop-types"
import React from "react"
import { StaticQuery, graphql, navigate } from 'gatsby'

const CATEGORY_ORDER = ['oldTestament', 'newTestament', 'topical']
const CATEGORY_LABELS = {
  oldTestament: 'Old Testament',
  newTestament: 'New Testament',
  topical: 'Topical',
}

class Header extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showNav: false
    }
  }

  componentDidUpdate (_prevProps, prevState) {
    if (prevState.showNav !== this.state.showNav) {
      const lock = this.state.showNav
      document.body.style.overflow = lock ? 'hidden' : ''
      document.documentElement.style.overflow = lock ? 'hidden' : ''
    }
  }

  componentWillUnmount () {
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }

  render () {
    const { showNav } = this.state
  
    return (
      <StaticQuery
        query={graphql`
          query {
            allStudiesJson {
              nodes {
                name
                slug
                category
              }
            }
          }
        `}
        render={data => {
          const nodes = data.allStudiesJson.nodes
          const groups = CATEGORY_ORDER.map(key => ({
            key,
            label: CATEGORY_LABELS[key],
            studies: nodes
              .filter(n => (n.category || 'oldTestament') === key)
              .sort((a, b) => a.name.localeCompare(b.name)),
          })).filter(g => g.studies.length > 0)
          const oldTestamentGroup = groups.find(g => g.key === 'oldTestament')
          const rightColumnGroups = groups.filter(g => g.key !== 'oldTestament')
          return (
          <header
            style={{
              background: `rebeccapurple`,
              marginBottom: `1.45rem`,
            }}
          >
            <div id="hamburger" onClick={() => this.setState({ showNav: !showNav })}>
              <div className={`line top-line ${showNav ? 'active' : ''}`}></div>
              <div className={`line middle-line ${showNav ? 'active' : ''}`}></div>
              <div className={`line bottom-line ${showNav ? 'active' : ''}`}></div>
            </div>
            {showNav && 
              <div id="study-selector" className="completely">
                <div className="study-menu-inner">
                  <div className="study-menu-columns">
                    <div className="study-menu-column study-menu-column--left">
                      {oldTestamentGroup && (
                        <div className="study-menu-section">
                          <h2 className="study-menu-heading">{oldTestamentGroup.label}</h2>
                          <ul>
                            {oldTestamentGroup.studies.map(s => (
                              <li key={s.slug} className="study-option" onClick={() => {
                                localStorage.setItem('lastLesson', s.slug)
                                this.setState({ showNav: false});
                                navigate('/' + s.slug)
                              }}>{s.name}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="study-menu-column study-menu-column--right">
                      {rightColumnGroups.map(g => (
                        <div key={g.key} className="study-menu-section">
                          <h2 className="study-menu-heading">{g.label}</h2>
                          <ul>
                            {g.studies.map(s => (
                              <li key={s.slug} className="study-option" onClick={() => {
                                localStorage.setItem('lastLesson', s.slug)
                                this.setState({ showNav: false});
                                navigate('/' + s.slug)
                              }}>{s.name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            }
          </header>
        )}}
      />
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
